import { createFileRoute, Navigate } from "@tanstack/react-router";

export const Route = createFileRoute("/fermentations/protocols/$protocol_id/")({
  component: () => {
    const { protocol_id } = Route.useParams();
    return (
      <Navigate
        to="/fermentations/protocols/$protocol_id/overview"
        params={{ protocol_id }}
        replace
      />
    );
  },
});
